<script>
  import { _, locale, lget } from "./i18n.js";
  import { f7, Button, Icon } from "framework7-svelte";
  import { addItem } from "./CartService.js";
  import { getProfile } from "./UserService.js";
  import { DOUBLE_COL } from "./ProductLayoutMenu.svelte";

  export let f7router;
  export let product;
  export let length = 0;
  export let productLayout;

  let titleClass =
    $productLayout === DOUBLE_COL && length == 2 ? "title2Col" : "title";
  let imageClass = $productLayout === DOUBLE_COL ? "image2Col" : "image";

  function getTitle(product) {
    let title = lget(product, "title", $locale);
    if (title.indexOf(",") != -1) {
      return title.split(",")[0].trim();
    } else {
      return title;
    }
  }

  function getSubTitle(product) {
    let title = lget(product, "title", $locale);
    if (title.indexOf(",") != -1) {
      return title.split(",")[1].trim();
    } else {
      return "";
    }
  }

  let addToCart = function(productId) {
    var dialog = f7.dialog.preloader($_("product.addingItem") + "...");
    getProfile().then(profile =>
      addItem(profile.userId, productId, 1).then(function() {
        dialog.close();

        if (f7router.previousRoute.url == "/Cart") {
          f7router.back("/Cart");
        } else {
          f7router.navigate("/Cart");
        }
      })
    );
  };
</script>

<style>
  .title,
  .title2Col {
    margin-top: 0px;
    margin: 10px;
    margin-bottom: 0px;
  }

  .title2Col {
    height: 95px;
  }

  .image {
    max-width: 400px;
    max-height: 250px;
    width: 100%;
  }

  .image2Col {
    max-width: 100%;
    max-height: 250px;
    height: 150px;
  }

  .price {
    font-size: 1.2rem;
    font-weight: bold;
    color: rgb(0, 122, 255);
  }
</style>

<div id={product.id}>
  <h2 class={titleClass}>{getTitle(product)}</h2>
  <h3 style="margin-top: 0px; font-style: italic;">{getSubTitle(product)}</h3>
  <img
    style="margin-top: 10px; text-align: center"
    class={imageClass}
    alt={lget(product, 'title', $locale)}
    src={product.image} />
  <div style="margin-top: 10px; font-size: 0px" class="price">
    <span style="font-size: 1.4rem;">
      {new Number(product.price).toLocaleString($locale, {
        minimumFractionDigits: 2
      })} THB
    </span>
    <span style="margin-left: 2px; font-size: 0.8rem">
      /{lget(product, 'unit', $locale)}
    </span>
  </div>
  <div style="margin: 30px">
    <Button
      color="green"
      fill
      round
      on:click={() => addToCart(product.id, function() {
          if (f7router.previousRoute.url == '/Cart') {
            f7router.back('/Cart');
          } else {
            f7router.navigate('/Cart');
          }
        })}>
      {$_('product.addToCart')}
      <Icon
        style="margin-left: 5px; vertical-align: text-top"
        icon="icon-plus" />
    </Button>
  </div>
</div>
